<template>
  <table
    class="tw-w-full tw-h-full"
  >
    <tbody>
      <tr>
        <td
          v-for="day in days"
          :key="day.desktop"
          class="tw-text-center tw-align-bottom"
        >
          <font-awesome-icon
            class="all-access-color tw-text-sm"
            :icon="['fas', 'lock']"
          />
          <div
            class="text-regular-color tw-pt-2 tw-text-sm"
          >
            <span class="lg:tw-hidden">
              {{ day.mobile }}
            </span>
            <span class="tw-hidden lg:tw-inline">
              {{ day.desktop }}
            </span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'SnowForecastLockedChart',

  props: {
    endDay: {
      type: Number,
      default: 4,
    },
    location: {
      type: Object,
      required: true,
    },
    startDay: {
      type: Number,
      default: 0,
    },
    useHistory: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    days() {
      return this.forecasts
        .slice(this.startDay, this.endDay + 1)
        .map((days) => ({
          mobile: this.$dayjs(days.date).format('dd').slice(0, 1),
          desktop: this.$dayjs(days.date).format('ddd D'),
        }));
    },

    forecasts() {
      const field = this.useHistory ? 'history_snow_daily' : 'forecast_snow_daily';

      if (this.location?.[field]?.length) {
        return this.location[field]
          .map((day) => ({ date: day.display_at, precipSnow: Math.round(day.precip_snow) }));
      }

      return [];
    },
  },
};
</script>
